<template>
  <div class="show-material">
    <LoadingSpinner v-if="isLoading" />

    <div v-else>
      <PageHeader title="Edit Material" />

      <div class="shadow p-5 mt-2 mb-5 bg-white rounded">
        <MaterialForm
          :model="material"
          :save-function="updateMaterial"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { Material } from '@/models/material'
import PageHeader from '@/components/app/AppPageHeader.vue'
import { useHead } from '@unhead/vue'
import MaterialForm from '../components/MaterialForm.vue'
import { useRoute, useRouter } from 'vue-router'
import { useQuery, useMutation, useQueryClient } from '@tanstack/vue-query'
import MaterialService from '@/services/MaterialService'
import LoadingSpinner from '@/components/LoadingSpinner.vue'
import { useNotification } from '@kyvg/vue3-notification'

useHead({ title: 'Edit Material' })

const { notify } = useNotification()
const $router = useRouter()
const $route = useRoute()
const materialId = $route.params.id as string || ''
const materialService = new MaterialService()
const queryClient = useQueryClient()

const { data: material, isLoading } = useQuery({
  queryKey: ['material', materialId],
  queryFn: () => materialService.find(materialId),

})

const { mutateAsync: updateMaterial } = useMutation({
  mutationFn: (material: Material) => materialService.update(materialId, material),
  onSuccess: (updatedMaterial: Material) => {
    queryClient.setQueryData(['material', updatedMaterial.id], updatedMaterial)
    queryClient.invalidateQueries({ queryKey: ['materials'] })
    notify({
      type: 'success',
      title: 'Material updated',
      text: 'Material updated successfully'
    })
    $router.push({ name: 'ListMaterials' })
  },
  onError: (error) => {
    notify({
      type: 'error',
      title: 'Error',
      text: error.message || 'An error occurred while trying to update the material'
    })
  }
})
</script>
